import React, { FC, useCallback, useContext, useMemo } from 'react';
import AnimatedCard from '../../../AnimatedCard';
import styles from './index.module.scss';
import { getSVG } from '@/components/Common/styles/mixins';
import { NolPromotionStoreCtx } from '@/stores/NolPromotionStore';
import { observer } from 'mobx-react-lite';

const NolCouponCard: FC = () => {
  const getResourcePath = useCallback((path: string): string => getSVG(`/static/images/nol-promotion/v9/${path}`), []);
  const store = useContext(NolPromotionStoreCtx);
  console.log(store);
  const nolCouponCardProps = useMemo(() => {
    return {
      type: 'gray' as const,
      supTitle: <div className={styles.cardSupTitle}>이벤트 1</div>,
      title: (
        <div className={styles.cardTitle}>
          NOL 카드 전용
          <br />
          <span className={styles.blue}>13만원 할인</span>
          <br />
          <span className={styles.blue}>웰컴 쿠폰팩 제공</span>
        </div>
      ),
      image: (
        <img
          className={styles.nolCouponImage}
          src={getResourcePath('v28_nol_card_coupon_pack.png')}
          alt={'NOL 카드 전용 10% 쿠폰 5장'}
        />
      ),

      descriptions: [
        {
          text: <>이벤트 기간 : {store.eventPeriod}</>,
          bold: false,
          normal: true,
        },
        {
          text: (
            <>
              대상 : NOL 카드 보유 회원(본인 회원에 한함)
              <br />- NOL 카드 페이에 NOL 카드를 등록한 회원 중 상세 조건 충족 시 제공
            </>
          ),
          bold: false,
          normal: true,
        },
        {
          text: (
            <>
              혜택 및 상세 조건
              <ul className={styles.dotDescriptions}>
                <li>
                  NOL 카드 전용 웰컴쿠폰(최대 13만원 할인) : NOL 카드 페이에 NOL 카드 최초 등록 후 30일 이내 NOL
                  회원으로 가입 시 즉시 제공
                  <br />
                  : 국내숙소 4만원X2매, 해외숙소 4만원, 레저/고속버스 각 5천원 할인
                  <br />
                  <u>* NOL 카드 교체 · 해지 및 재발급하여 재등록 시 이벤트 대상에서 제외</u>
                </li>
                <li>
                  NOL 카드 전용 실적쿠폰(10% X 5매) : NOL 카드 전월 실적 40만원 이상 달성 시 매월 1회 발행
                  <br />: 국내숙소 최대 3만원, 해외숙소 최대 1.5만원, 렌트카/레저/고속버스 각 최대 5천원 할인
                  <br />
                </li>
              </ul>
            </>
          ),
          bold: false,
          normal: true,
        },
        {
          text: <>이벤트 유의사항 및 상세 내용은 자세히 보기 참조</>,
          bold: false,
          normal: true,
        },
      ],
    };
  }, []);

  return (
    <AnimatedCard
      className={styles.nolCouponCardContainer}
      {...nolCouponCardProps}
      onDetailClick={() => (store.isDiscountCouponBottomSheetOpen = true)}
      logData={{
        object: '자세히 보기',
        objectType: 'Btn',
        objectContainer: 'NOL에서 지금 받는 NOL 이벤트 혜택',
        motherPageVersion: store.version,
        motherPageSectionType: '혜택',
        motherPageSectionName: 'NOL 카드 전용 13만원 할인 웰컴 쿠폰팩 제공',
        deepLinkUri: '',
      }}
    />
  );
};

export default observer(NolCouponCard);
